import { trigger, transition, style, animate } from '@angular/animations';

export const gridAnnimations = [
    // Backdrop fade — shared by both bottom sheets
    trigger('backdropFade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('150ms ease-out', style({ opacity: 0 }))
      ])
    ]),
    // Parameterized panel reveal — adapts between mobile sheet slide and desktop dropdown
    // Mobile filter uses enterEndTransform: 'none' so native selects anchor correctly (no transform stacking context)
    trigger('panelReveal', [
      transition(':enter', [
        style({ opacity: '{{ startOpacity }}', transform: '{{ startTransform }}' }),
        animate('{{ enterTiming }}', style({ opacity: 1, transform: '{{ enterEndTransform }}' }))
      ], {
        params: {
          startOpacity: '0',
          startTransform: 'scale(0.96)',
          enterTiming: '150ms cubic-bezier(0.23, 1, 0.32, 1)',
          enterEndTransform: 'translateY(0) scale(1)'
        }
      }),
      transition(':leave', [
        animate('{{ leaveTiming }}', style({ opacity: '{{ endOpacity }}', transform: '{{ endTransform }}' }))
      ], {
        params: {
          endOpacity: '0',
          endTransform: 'scale(0.96)',
          leaveTiming: '100ms ease-out'
        }
      })
    ])
  ];